// extracted by mini-css-extract-plugin
export default {"container":"Home_container__9Vhrm","loader":"Home_loader__-85kY","movies":"Home_movies__zbx+8","icon":"Home_icon__roz20"};